<form [formGroup]="form" [formEditablePermission]="form">
  <div class="row">
    <!-- Title -->
    <div class="col-sm-12">
      <mat-form-field2 class="mat-block">
        <input
          type="text"
          matInput
          required
          i18n-placeholder
          placeholder="Title"
          formControlName="title"
          tabindex="1"
        />
        <mat-error *ngIf="form.get('title').touched && form.get('title').hasError('required')">
          <ng-container i18n>Title is required</ng-container>
        </mat-error>
        <mat-error *ngIf="form.get('title').touched && form.get('title').hasError('maxlength')">
          <ng-container i18n>Title must be at most 50 characters long</ng-container>
        </mat-error>
        <mat-error *ngIf="form.get('title').touched && form.get('title').hasError('allSpaces')">
          <ng-container i18n>Title cannot be spaces alone.</ng-container>
        </mat-error>
        <mat-hint align="end">{{ form.get('title').value?.length || 0 }}/50</mat-hint>
      </mat-form-field2>
    </div>

    <!-- Start -->
    <div class="col-sm-6">
      <mat-form-field2 class="mat-block">
        <app-mat-date-input
          placeholder="Start"
          i18n-placeholder
          formControlName="start"
          [max]="maxStartDate.value"
          required
        ></app-mat-date-input>

        <i matPrefix class="cs-icon cs-icon-calendar"></i>
        <mat-error *ngIf="form.get('start').touched && form.get('start').hasError('required')">
          <ng-container i18n>Start is required</ng-container>
        </mat-error>
        <mat-error *ngIf="form.get('start').hasError('min')">
          <ng-container i18n>Min value is</ng-container>&nbsp;
          <strong>{{ form.get('start').getError('min').min | epoch : 'date' }}</strong>
        </mat-error>
        <mat-error *ngIf="form.get('start').hasError('max')">
          <ng-container i18n>Max value is</ng-container>&nbsp;
          <strong>{{ form.get('start').getError('max').max | epoch : 'date' }}</strong>
        </mat-error>
      </mat-form-field2>
    </div>
    <div class="col-sm-6">
      <mat-form-field2 class="mat-block">
        <app-mat-date-input
          placeholder="End"
          i18n-placeholder
          formControlName="end"
          [min]="minEndDate.value"
          required
        ></app-mat-date-input>

        <i matPrefix class="cs-icon cs-icon-calendar"></i>
        <mat-error *ngIf="form.get('end').touched && form.get('end').hasError('required')">
          <ng-container i18n>End is required</ng-container>
        </mat-error>
        <mat-error *ngIf="form.get('end').hasError('min')">
          <ng-container i18n>Min value is</ng-container>&nbsp;
          <strong>{{ form.get('end').getError('min').min | epoch : 'date' }}</strong>
        </mat-error>
        <mat-error *ngIf="form.get('end').hasError('max')">
          <ng-container i18n>Max value is</ng-container>&nbsp;
          <strong>{{ form.get('end').getError('max').max | epoch : 'date' }}</strong>
        </mat-error>
      </mat-form-field2>
    </div>

    <!-- Type -->
    <div class="col-sm-6">
      <mat-form-field2 class="mat-block">
        <mat-select
          matTooltip="Hold Events will be sent to your connected channels and calendars."
          matTooltipPosition="above"
          i18n-matTooltip
          formControlName="type"
          placeholder="Type"
          i18n-placeholder
          [tabIndex]="2"
        >
          <mat-option *ngFor="let type of types" [value]="type.id">{{ type.name }}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('type').touched && form.get('type').hasError('required')">
          <ng-container i18n>Type is required</ng-container>
        </mat-error>
      </mat-form-field2>
    </div>
    <!-- Expires -->
    <div class="col-sm-6">
      <mat-form-field2 class="mat-block">
        <app-mat-date-input
          formControlName="expires"
          placeholder="Expires"
          i18n-placeholder
          [min]="minExpirationDate"
          matTooltip="This Hold Event will be automatically removed from AdvanceCM on the expiration date."
          matTooltipPosition="above"
          i18n-matTooltip
        ></app-mat-date-input>

        <i matPrefix class="cs-icon cs-icon-calendar"></i>
        <mat-error *ngIf="form.get('expires').hasError('min')">
          <ng-container i18n>Min value is</ng-container>&nbsp;
          <strong>{{ form.get('expires').getError('min').min | epoch : 'date' }}</strong>
        </mat-error>
        <mat-error *ngIf="form.get('expires').hasError('max')">
          <ng-container i18n>Max value is</ng-container>&nbsp;
          <strong>{{ form.get('expires').getError('max').max | epoch : 'date' }}</strong>
        </mat-error>
      </mat-form-field2>
    </div>
    <div class="col-md-12">
      <mat-form-field2 class="mat-block">
        <mat-label i18n>Description</mat-label>
        <textarea
          matInput
          #notes
          maxlength="500"
          rows="3"
          formControlName="description"
          placeholder="Enter description"
          i18n-placeholder
          cdkTextareaAutosize
          [cdkAutosizeMaxRows]="5"
        ></textarea>
      </mat-form-field2>
    </div>

    <div class="col-sm-12">
      <app-guest-select [ctrl]="form.get('guest_id')"></app-guest-select>
    </div>

    <!-- Rentals -->
    <div class="col-sm-12" *ngIf="!isEdit">
      <app-rental-select
        i18n-placeholder
        [ctrl]="form.get('rentalIds')"
        [excludeDisabledSubunits]="true"
        placeholder="Select Rental(s)"
      >
      </app-rental-select>
    </div>
    <div class="col-sm-12" *ngIf="isEdit">
      <app-rental-select
        i18n-placeholder
        [multiple]="false"
        [excludeDisabledSubunits]="true"
        [ctrl]="form.get('rental_id')"
        placeholder="Select Rental"
      >
      </app-rental-select>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-6">
      <mat-checkbox
        matTooltip="Check this box and AdvanceCM will keep shifting your hold event forward by 1 day every 24 hours."
        matTooltipPosition="above"
        i18n-matTooltip
        [checked]="!!form.get('rolling').value"
        (change)="onRollingChanged($event)"
        i18n
        >Roll Forward</mat-checkbox
      >
    </div>
    <div class="col-sm-12 mt-3">
      <label i18n>Select Color</label>
      <app-color-boxes [ctrl]="form.get('color')"></app-color-boxes>
    </div>
  </div>
</form>
